import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { CategoriesService } from '../service/categories.service';
import * as CategoryActions from './categories.actions';
import { of, catchError, filter, map, switchMap, take } from 'rxjs';
import { AuthService } from '@frontend/util-client-auth';
import { CLIENT_DATA, ClientData } from '@frontend/util-api-data';

@Injectable()
export class CategoriesEffects {
  private actions$ = inject(Actions);
  private categoriesService = inject(CategoriesService);
  private authService = inject(AuthService);
  private clientData = inject<ClientData>(CLIENT_DATA);

  getCategories$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CategoryActions.categoryPageOpened),
      switchMap((action) => {
        // only schueco uses the keycloak client where we need to wait for init
        if (this.clientData.name !== 'schueco') {
          return of(action);
        }
        return this.authService.isInitialized$.pipe(
          filter((value) => value),
          take(1),
          map((_) => action)
        );
      }),
      switchMap((action) => {
        return this.categoriesService.getCategories(action.id, action.language).pipe(
          map((_response) => CategoryActions.loadCategoriesSuccess({ categories: _response })),
          catchError((error) => of(CategoryActions.loadCategoriesFailure({ error })))
        );
      })
    )
  );
}
